import Const from 'constants';

const GeneratorType = {
    setGeneratorTypeFromStorage(generatorType) {
        return (dispatch) => {
            dispatch(this.setGeneratorType(generatorType, {saveToStorage: false}));
        };
    },

    setGeneratorType(generatorType, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_GENERATOR_TYPE,
                generatorType,
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('generatorType', function (state) {
                    const {lineupGenerator, sportConfig} = state;

                    return lineupGenerator.settings.getGeneratorType(sportConfig);
                }),
            );
        };
    },
};

export default GeneratorType;
